<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uEHf2W/tc-custom/9781423616375.jpg?1736887538821" alt="This image is the cover for the book 101 More Things To Do With Ramen Noodles, 101 Things To Do With"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">101 More Things To Do With Ramen Noodles, 101 Things To Do With
      </h1>
      <p class="bookDescription body article font2">
        <b>A new collection of uncommon ways to make ramen!</b><br/>  <br/> Ramen-meister Toni Patrick has again worked her magic with these humble noodles to create even more tasty recipes—from breakfast to dessert and everything in between. Grab your fork and give these dishes a whirl: <br/>   Ricotta FrittataCorn ChowderGrilled RamenBroccoli and Ham CasserolePad ThaiTurkey-Pasta PieHot and Sour RamenCrab Lo Mein, and many more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Toni Patrick
      </h2>
      
      <p class="authorDescription body article">Toni Patrick is also the author of 101 Things to Do with Ramen Noodles, 101 Things to Do with Mac & Cheese, and 101 Things to Do with Canned Biscuits. She lives in Colorado.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ad43c772